import { defineMessages } from "@/lib/i18n/messages";

const plural = (n: number, one: string, many: string) => `${n} ${n === 1 ? one : many}`;

export default defineMessages({
  es: {
    title: "Notificaciones",
    loading: "Cargando…",
    empty: "No hay notificaciones todavía.",
    invited: (creator: string, panorama: string) => `${creator} te invitó a ${panorama}`,
    syncSummary: (created: number, updated: number, failed: number) =>
      `${plural(created, "nuevo", "nuevos")}, ${plural(updated, "actualizado", "actualizados")}` +
      (failed > 0 ? `, ${failed} con error` : ""),
    seeAll: "Ver todas",
  },
  en: {
    title: "Notifications",
    loading: "Loading…",
    empty: "No notifications yet.",
    invited: (creator: string, panorama: string) => `${creator} invited you to ${panorama}`,
    syncSummary: (created: number, updated: number, failed: number) =>
      `${created} new, ${updated} updated` + (failed > 0 ? `, ${failed} failed` : ""),
    seeAll: "See all",
  },
});
